/** @jsxImportSource react */
import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from '@mui/material'
import PersonInput from './PersonInput'

/** Choose which person field (e.g. Owner) and who to set it to, for the selected records. */
const BulkAssignDialog = ({ open, count, personFields, busy, onAssign, onClose }) => {
  const [fieldKey, setFieldKey] = useState(personFields[0]?.fieldKey || '')
  const [person, setPerson] = useState('')
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth TransitionProps={{ onEnter: () => { setFieldKey(personFields[0]?.fieldKey || ''); setPerson('') } }}>
      <DialogTitle>Assign {count} {count === 1 ? 'record' : 'records'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {personFields.length > 1 && (
            <TextField select label="Field" value={fieldKey} onChange={(e) => setFieldKey(e.target.value)}>
              {personFields.map((f) => <MenuItem key={f.fieldKey} value={f.fieldKey}>{f.label}</MenuItem>)}
            </TextField>
          )}
          <PersonInput value={person} onChange={setPerson} label={personFields.find((f) => f.fieldKey === fieldKey)?.label || 'Person'} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={busy || !person || !fieldKey} onClick={() => onAssign(fieldKey, person)}>Assign</Button>
      </DialogActions>
    </Dialog>
  )
}

export default BulkAssignDialog
